import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import jwtDecode from 'jwt-decode'

import { Button } from 'components'
import Colors from 'utils/Colors'
import { AUTOMATIC_QUESTION_FORM_TYPES } from 'utils/constants/automaticQuestionTypes'
import { USER_ROLES } from 'utils/constants/userRoles'

import styles from './styles'

function QuestionItem(props) {
  const { question, action } = props

  const classes = styles()

  const token = useSelector((state) => state.auth.access_token)
  const currentRole = jwtDecode(token)?.extras?.role

  return (
    <div className={classes.questions}>
      <div className={classes.statusBar}>
        <span
          className={classes.status}
          style={{
            backgroundColor: question.answered
              ? Colors.green
              : Colors.googleYellow,
          }}
        >
          {question.answered ? 'respondida' : 'pendente'}
        </span>
        {question?.subject ? (
          <span
            className={classes.status}
            style={{
              backgroundColor: Colors.gray,
            }}
          >
            {AUTOMATIC_QUESTION_FORM_TYPES[question.subject] || question.subject}
          </span>
        ) : null}
      </div>
      <p>{`${question.text.slice(0, 120)}...`}</p>
      <div className={classes.buttonsContainer}>
        <Button onClick={action}>
          {question.answered ||
          (currentRole !== USER_ROLES.PROSPECT)
            ? 'Visualizar'
            : 'Responder'}
        </Button>
      </div>
    </div>
  )
}

QuestionItem.propTypes = {
  question: PropTypes.shape({
    uuid: PropTypes.string.isRequired,
    answered: PropTypes.bool.isRequired,
    text: PropTypes.string.isRequired,
    answer_object: PropTypes.shape({
      attachments: PropTypes.array,
      text: PropTypes.string,
    }),
  }).isRequired,
}

export default QuestionItem
